import ToastsContainer from "../../../Components/BonusUi/Toasts/ToastsContainer";

const Toasts = () => {
  return <ToastsContainer />;
};

export default Toasts;
